module.exports = __webpack_public_path__ + "static/media/pin.30a0b292.svg";